import { readContract, writeContract, waitForTransactionReceipt, getAccount } from '@wagmi/core';
import { parseEther, formatEther, parseUnits, formatUnits } from 'viem';
import { wagmiConfig } from '../providers/WalletProvider';

// Re-export utility functions for convenience
export { parseEther, formatEther, parseUnits, formatUnits };

// Contract address
export const CONTRACT_ADDRESS = '0x1b3f2f99cc5eaD46084075751372F9dE9133f18e';

// ERC20 ABI for USDT token (approve and allowance functions)
export const ERC20_ABI = [
  {
    "inputs": [
      { "internalType": "address", "name": "owner", "type": "address" },
      { "internalType": "address", "name": "spender", "type": "address" }
    ],
    "name": "allowance",
    "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      { "internalType": "address", "name": "spender", "type": "address" },
      { "internalType": "uint256", "name": "amount", "type": "uint256" }
    ],
    "name": "approve",
    "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }],
    "stateMutability": "nonpayable",
    "type": "function"
  }
];

// Contract ABI
export const CONTRACT_ABI = [
  {
    "inputs": [
      { "internalType": "address", "name": "_btc", "type": "address" },
      { "internalType": "address", "name": "_eth", "type": "address" },
      { "internalType": "address", "name": "_bnb", "type": "address" },
      { "internalType": "address", "name": "_usdt", "type": "address" }
    ],
    "stateMutability": "nonpayable",
    "type": "constructor"
  },
  {
    "anonymous": false,
    "inputs": [
      { "indexed": true, "internalType": "uint256", "name": "id", "type": "uint256" },
      { "indexed": true, "internalType": "address", "name": "user", "type": "address" },
      { "indexed": false, "internalType": "bool", "name": "isYes", "type": "bool" },
      { "indexed": false, "internalType": "uint256", "name": "grossAmount", "type": "uint256" },
      { "indexed": false, "internalType": "uint256", "name": "fee", "type": "uint256" },
      { "indexed": false, "internalType": "uint256", "name": "netStake", "type": "uint256" }
    ],
    "name": "MarketBetPlaced",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      { "indexed": true, "internalType": "uint256", "name": "id", "type": "uint256" },
      { "indexed": true, "internalType": "address", "name": "user", "type": "address" },
      { "indexed": false, "internalType": "bool", "name": "won", "type": "bool" },
      { "indexed": false, "internalType": "uint256", "name": "payout", "type": "uint256" }
    ],
    "name": "MarketClaimed",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      { "indexed": true, "internalType": "uint256", "name": "id", "type": "uint256" },
      { "indexed": true, "internalType": "address", "name": "creator", "type": "address" },
      { "indexed": false, "internalType": "bool", "name": "stakeInUSDT", "type": "bool" },
      { "indexed": false, "internalType": "enum IOTraderUnified.Pair", "name": "pair", "type": "uint8" },
      { "indexed": false, "internalType": "uint256", "name": "targetPrice", "type": "uint256" },
      { "indexed": false, "internalType": "uint256", "name": "endTime", "type": "uint256" },
      { "indexed": false, "internalType": "string", "name": "question", "type": "string" }
    ],
    "name": "MarketCreated",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      { "indexed": true, "internalType": "uint256", "name": "id", "type": "uint256" },
      { "indexed": false, "internalType": "bool", "name": "yesWon", "type": "bool" },
      { "indexed": false, "internalType": "uint256", "name": "settledPrice", "type": "uint256" }
    ],
    "name": "MarketSettled",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      { "indexed": true, "internalType": "uint256", "name": "id", "type": "uint256" },
      { "indexed": true, "internalType": "address", "name": "user", "type": "address" },
      { "indexed": false, "internalType": "bool", "name": "won", "type": "bool" },
      { "indexed": false, "internalType": "uint256", "name": "settledPrice", "type": "uint256" },
      { "indexed": false, "internalType": "uint256", "name": "payout", "type": "uint256" }
    ],
    "name": "PredictionClaimed",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      { "indexed": true, "internalType": "uint256", "name": "id", "type": "uint256" },
      { "indexed": true, "internalType": "address", "name": "user", "type": "address" },
      { "indexed": false, "internalType": "bool", "name": "isLong", "type": "bool" },
      { "indexed": false, "internalType": "bool", "name": "stakeInUSDT", "type": "bool" },
      { "indexed": false, "internalType": "enum IOTraderUnified.Pair", "name": "pair", "type": "uint8" },
      { "indexed": false, "internalType": "uint256", "name": "targetPrice", "type": "uint256" },
      { "indexed": false, "internalType": "uint256", "name": "expiry", "type": "uint256" },
      { "indexed": false, "internalType": "uint256", "name": "gross", "type": "uint256" },
      { "indexed": false, "internalType": "uint256", "name": "fee", "type": "uint256" },
      { "indexed": false, "internalType": "uint256", "name": "net", "type": "uint256" }
    ],
    "name": "PredictionOpened",
    "type": "event"
  },
  {
    "inputs": [],
    "name": "BNB_USD",
    "outputs": [{ "internalType": "address", "name": "", "type": "address" }],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "BTC_USD",
    "outputs": [{ "internalType": "address", "name": "", "type": "address" }],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "ETH_USD",
    "outputs": [{ "internalType": "address", "name": "", "type": "address" }],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "MAX_LOOKBACK",
    "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "USDT",
    "outputs": [{ "internalType": "address", "name": "", "type": "address" }],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      { "internalType": "uint256", "name": "marketId", "type": "uint256" },
      { "internalType": "uint256", "name": "usdtAmount", "type": "uint256" }
    ],
    "name": "betNo",
    "outputs": [],
    "stateMutability": "payable",
    "type": "function"
  },
  {
    "inputs": [
      { "internalType": "uint256", "name": "marketId", "type": "uint256" },
      { "internalType": "uint256", "name": "usdtAmount", "type": "uint256" }
    ],
    "name": "betYes",
    "outputs": [],
    "stateMutability": "payable",
    "type": "function"
  },
  {
    "inputs": [{ "internalType": "uint256", "name": "id", "type": "uint256" }],
    "name": "claimPrediction",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [{ "internalType": "uint256", "name": "marketId", "type": "uint256" }],
    "name": "claimYesNo",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      { "internalType": "string", "name": "question", "type": "string" },
      { "internalType": "enum IOTraderUnified.Pair", "name": "pair", "type": "uint8" },
      { "internalType": "uint256", "name": "targetPrice", "type": "uint256" },
      { "internalType": "uint256", "name": "duration", "type": "uint256" },
      { "internalType": "bool", "name": "stakeInUSDT", "type": "bool" }
    ],
    "name": "createYesNoMarket",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "feeBps",
    "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [{ "internalType": "address", "name": "user", "type": "address" }],
    "name": "getUserPredictions",
    "outputs": [{ "internalType": "uint256[]", "name": "", "type": "uint256[]" }],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      { "internalType": "enum IOTraderUnified.Pair", "name": "pair", "type": "uint8" },
      { "internalType": "uint256", "name": "targetPrice", "type": "uint256" },
      { "internalType": "uint256", "name": "duration", "type": "uint256" },
      { "internalType": "bool", "name": "stakeUSDT", "type": "bool" },
      { "internalType": "uint256", "name": "usdtAmount", "type": "uint256" }
    ],
    "name": "long",
    "outputs": [],
    "stateMutability": "payable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "marketCount",
    "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }],
    "name": "markets",
    "outputs": [
      { "internalType": "uint256", "name": "id", "type": "uint256" },
      { "internalType": "string", "name": "question", "type": "string" },
      { "internalType": "enum IOTraderUnified.Pair", "name": "pair", "type": "uint8" },
      { "internalType": "uint256", "name": "targetPrice", "type": "uint256" },
      { "internalType": "uint256", "name": "endTime", "type": "uint256" },
      { "internalType": "bool", "name": "stakeInUSDT", "type": "bool" },
      { "internalType": "uint256", "name": "yesPool", "type": "uint256" },
      { "internalType": "uint256", "name": "noPool", "type": "uint256" },
      { "internalType": "bool", "name": "outcomeYes", "type": "bool" },
      { "internalType": "uint256", "name": "settledPrice", "type": "uint256" },
      { "internalType": "enum IOTraderUnified.MarketState", "name": "state", "type": "uint8" },
      { "internalType": "address", "name": "creator", "type": "address" }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "owner",
    "outputs": [{ "internalType": "address", "name": "", "type": "address" }],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "predictionCount",
    "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }],
    "name": "predictions",
    "outputs": [
      { "internalType": "address", "name": "user", "type": "address" },
      { "internalType": "enum IOTraderUnified.Pair", "name": "pair", "type": "uint8" },
      { "internalType": "bool", "name": "isLong", "type": "bool" },
      { "internalType": "bool", "name": "stakeInUSDT", "type": "bool" },
      { "internalType": "uint256", "name": "stake", "type": "uint256" },
      { "internalType": "uint256", "name": "targetPrice", "type": "uint256" },
      { "internalType": "uint256", "name": "openTime", "type": "uint256" },
      { "internalType": "uint256", "name": "duration", "type": "uint256" },
      { "internalType": "uint256", "name": "settledPrice", "type": "uint256" },
      { "internalType": "enum IOTraderUnified.PredState", "name": "state", "type": "uint8" }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [{ "internalType": "uint256", "name": "f", "type": "uint256" }],
    "name": "setFeeBps",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [{ "internalType": "uint256", "name": "marketId", "type": "uint256" }],
    "name": "settleYesNoMarket",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      { "internalType": "enum IOTraderUnified.Pair", "name": "pair", "type": "uint8" },
      { "internalType": "uint256", "name": "targetPrice", "type": "uint256" },
      { "internalType": "uint256", "name": "duration", "type": "uint256" },
      { "internalType": "bool", "name": "stakeUSDT", "type": "bool" },
      { "internalType": "uint256", "name": "usdtAmount", "type": "uint256" }
    ],
    "name": "short",
    "outputs": [],
    "stateMutability": "payable",
    "type": "function"
  },
  {
    "inputs": [
      { "internalType": "uint256", "name": "", "type": "uint256" },
      { "internalType": "address", "name": "", "type": "address" }
    ],
    "name": "userMarketBets",
    "outputs": [
      { "internalType": "uint256", "name": "yesAmount", "type": "uint256" },
      { "internalType": "uint256", "name": "noAmount", "type": "uint256" },
      { "internalType": "bool", "name": "claimed", "type": "bool" }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      { "internalType": "address", "name": "", "type": "address" },
      { "internalType": "uint256", "name": "", "type": "uint256" }
    ],
    "name": "userPredictions",
    "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      { "internalType": "address payable", "name": "to", "type": "address" },
      { "internalType": "uint256", "name": "amount", "type": "uint256" }
    ],
    "name": "withdrawBNB",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      { "internalType": "address", "name": "to", "type": "address" },
      { "internalType": "uint256", "name": "amount", "type": "uint256" }
    ],
    "name": "withdrawUSDT",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  { "stateMutability": "payable", "type": "receive" }
];

// Pair enum mapping (0 = BTC, 1 = ETH, 2 = BNB, 3 = USDT)
export const Pair = {
  BTC: 0,
  ETH: 1,
  BNB: 2,
  USDT: 3,
};

/**
 * Get pair enum from symbol
 * @param {string} symbol - Crypto symbol (BTC, ETH, BNB, USDT)
 * @returns {number} Pair enum value
 */
export const getPairFromSymbol = (symbol) => {
  const upperSymbol = symbol.toUpperCase();
  if (upperSymbol === 'BTC') return Pair.BTC;
  if (upperSymbol === 'ETH') return Pair.ETH;
  if (upperSymbol === 'BNB') return Pair.BNB;
  if (upperSymbol === 'USDT') return Pair.USDT;
  throw new Error(`Unknown pair symbol: ${symbol}`);
};

/**
 * Get symbol from pair enum
 * @param {number} pair - Pair enum value
 * @returns {string} Crypto symbol
 */
export const getSymbolFromPair = (pair) => {
  if (pair === Pair.BTC) return 'BTC';
  if (pair === Pair.ETH) return 'ETH';
  if (pair === Pair.BNB) return 'BNB';
  if (pair === Pair.USDT) return 'USDT';
  return 'UNKNOWN';
};

/**
 * Market Functions
 */

/**
 * Get total number of markets
 * @returns {Promise<bigint>} Total market count
 */
export const getMarketCount = async () => {
  try {
    const result = await readContract(wagmiConfig, {
      address: CONTRACT_ADDRESS,
      abi: CONTRACT_ABI,
      functionName: 'marketCount',
    });
    return result;
  } catch (error) {
    console.error('Error getting market count:', error);
    throw error;
  }
};

/**
 * Get market by ID
 * @param {number} marketId - Market ID
 * @returns {Promise<Object>} Market data
 */
export const getMarket = async (marketId) => {
  try {
    const result = await readContract(wagmiConfig, {
      address: CONTRACT_ADDRESS,
      abi: CONTRACT_ABI,
      functionName: 'markets',
      args: [BigInt(marketId)],
    });

    return {
      id: Number(result[0]),
      question: result[1],
      pair: Number(result[2]),
      pairSymbol: getSymbolFromPair(Number(result[2])),
      targetPrice: formatUnits(result[3], 8), // Price feeds use 8 decimals
      endTime: Number(result[4]),
      stakeInUSDT: result[5],
      yesPool: result[5] ? formatUnits(result[6], 6) : formatEther(result[6]), // USDT has 6 decimals, BNB has 18
      noPool: result[5] ? formatUnits(result[7], 6) : formatEther(result[7]),
      outcomeYes: result[8],
      settledPrice: result[9] ? formatUnits(result[9], 8) : null,
      state: Number(result[10]), // 0: Active, 1: Settled
      creator: result[11],
    };
  } catch (error) {
    console.error(`Error getting market ${marketId}:`, error);
    throw error;
  }
};

/**
 * Get all markets
 * @returns {Promise<Array>} Array of all markets
 */
export const getAllMarkets = async () => {
  try {
    const count = await getMarketCount();
    const markets = [];

    for (let i = 0; i < Number(count); i++) {
      try {
        const market = await getMarket(i);
        markets.push(market);
      } catch (error) {
        console.warn(`Error fetching market ${i}:`, error);
      }
    }

    return markets;
  } catch (error) {
    console.error('Error getting all markets:', error);
    throw error;
  }
};

/**
 * Create a new Yes/No market
 * @param {string} question - Market question
 * @param {string|number} pair - Pair symbol (BTC, ETH, BNB, USDT) or enum value
 * @param {string|number} targetPrice - Target price (will be converted to 8 decimals for price feeds)
 * @param {number} duration - Duration in seconds
 * @param {boolean} stakeInUSDT - Whether to stake in USDT (true) or BNB (false)
 * @returns {Promise<string>} Transaction hash
 */
export const createYesNoMarket = async (question, pair, targetPrice, duration, stakeInUSDT = false) => {
  try {
    const pairEnum = typeof pair === 'string' ? getPairFromSymbol(pair) : pair;
    const targetPriceWei = parseUnits(targetPrice.toString(), 8); // Price feeds use 8 decimals

    const hash = await writeContract(wagmiConfig, {
      address: CONTRACT_ADDRESS,
      abi: CONTRACT_ABI,
      functionName: 'createYesNoMarket',
      args: [question, BigInt(pairEnum), targetPriceWei, BigInt(duration), stakeInUSDT],
    });

    return hash;
  } catch (error) {
    console.error('Error creating market:', error);
    throw error;
  }
};

/**
 * Legacy function name for backward compatibility
 * @deprecated Use createYesNoMarket instead
 */
export const createMarket = async (question, duration, oracle, threshold) => {
  // Map old parameters to new function
  // Default to BTC pair, convert threshold to targetPrice
  return createYesNoMarket(question, 'BTC', threshold.toString(), duration, false);
};

/**
 * Place a YES bet on a market
 * @param {number} marketId - Market ID
 * @param {string|number} usdtAmount - Amount in USDT (as string or number, e.g., "10" or 10)
 * @param {boolean} stakeInUSDT - Whether staking in USDT (true) or BNB (false)
 * @returns {Promise<string>} Transaction hash
 */
export const betYes = async (marketId, usdtAmount, stakeInUSDT = false) => {
  try {
    const amount = stakeInUSDT 
      ? parseUnits(usdtAmount.toString(), 6) // USDT has 6 decimals
      : parseEther(usdtAmount.toString()); // BNB has 18 decimals

    const hash = await writeContract(wagmiConfig, {
      address: CONTRACT_ADDRESS,
      abi: CONTRACT_ABI,
      functionName: 'betYes',
      args: [BigInt(marketId), 0],
      value: stakeInUSDT ? 0n : amount, // Only send BNB if not using USDT
    });

    return hash;
  } catch (error) {
   // console.error('Error betting YES on market:', error);
   // throw error;
  }
};

/**
 * Place a NO bet on a market
 * @param {number} marketId - Market ID
 * @param {string|number} usdtAmount - Amount in USDT (as string or number, e.g., "10" or 10)
 * @param {boolean} stakeInUSDT - Whether staking in USDT (true) or BNB (false)
 * @returns {Promise<string>} Transaction hash
 */
export const betNo = async (marketId, usdtAmount, stakeInUSDT = false) => {
  try {
    const amount = stakeInUSDT 
      ? parseUnits(usdtAmount.toString(), 6) // USDT has 6 decimals
      : parseEther(usdtAmount.toString()); // BNB has 18 decimals

    const hash = await writeContract(wagmiConfig, {
      address: CONTRACT_ADDRESS,
      abi: CONTRACT_ABI,
      functionName: 'betNo',
      args: [BigInt(marketId), 0],
      value:  amount, // Only send BNB if not using USDT
    });

    return hash;
  } catch (error) {
   // console.error('Error betting NO on market:', error);
    //throw error;
  }
};

/**
 * Legacy function name for backward compatibility
 * @deprecated Use betYes or betNo instead
 */
export const betOnMarket = async (marketId, isYes, amount) => {
  return isYes ? betYes(marketId, amount, false) : betNo(marketId, amount, false);
};

/**
 * Get user's bet on a market
 * @param {number} marketId - Market ID
 * @param {string} userAddress - User's wallet address
 * @param {boolean} stakeInUSDT - Whether the market uses USDT (true) or BNB (false)
 * @returns {Promise<Object>} User bet data
 */
export const getUserMarketBet = async (marketId, userAddress, stakeInUSDT = false) => {
  try {
    const result = await readContract(wagmiConfig, {
      address: CONTRACT_ADDRESS,
      abi: CONTRACT_ABI,
      functionName: 'userMarketBets',
      args: [BigInt(marketId), userAddress],
    });

    return {
      yesAmount: stakeInUSDT ? formatUnits(result[0], 6) : formatEther(result[0]),
      noAmount: stakeInUSDT ? formatUnits(result[1], 6) : formatEther(result[1]),
      claimed: result[2],
    };
  } catch (error) {
    console.error('Error getting user market bet:', error);
    throw error;
  }
};

/**
 * Settle a Yes/No market
 * @param {number} marketId - Market ID
 * @returns {Promise<string>} Transaction hash
 */
export const settleYesNoMarket = async (marketId) => {
  try {
    const hash = await writeContract(wagmiConfig, {
      address: CONTRACT_ADDRESS,
      abi: CONTRACT_ABI,
      functionName: 'settleYesNoMarket',
      args: [BigInt(marketId)],
    });

    return hash;
  } catch (error) {
    console.error('Error settling market:', error);
    throw error;
  }
};

/**
 * Legacy function name for backward compatibility
 * @deprecated Use settleYesNoMarket instead
 */
export const settleMarket = async (marketId) => {
  return settleYesNoMarket(marketId);
};

/**
 * Claim Yes/No market funds
 * @param {number} marketId - Market ID
 * @returns {Promise<string>} Transaction hash
 */
export const claimYesNo = async (marketId) => {
  try {
    const hash = await writeContract(wagmiConfig, {
      address: CONTRACT_ADDRESS,
      abi: CONTRACT_ABI,
      functionName: 'claimYesNo',
      args: [BigInt(marketId)],
    });

    return hash;
  } catch (error) {
    console.error('Error claiming market funds:', error);
    throw error;
  }
};

/**
 * Legacy function name for backward compatibility
 * @deprecated Use claimYesNo instead
 */
export const claimMarketFunds = async (marketId) => {
  return claimYesNo(marketId);
};

/**
 * Prediction Functions
 */

/**
 * Get total number of predictions
 * @returns {Promise<bigint>} Total prediction count
 */
export const getPredictionCount = async () => {
  try {
    const result = await readContract(wagmiConfig, {
      address: CONTRACT_ADDRESS,
      abi: CONTRACT_ABI,
      functionName: 'predictionCount',
    });
    return result;
  } catch (error) {
    console.error('Error getting prediction count:', error);
    throw error;
  }
};

/**
 * Get prediction by ID
 * @param {number} predictionId - Prediction ID
 * @returns {Promise<Object>} Prediction data
 */
export const getPrediction = async (predictionId) => {
  try {
    const result = await readContract(wagmiConfig, {
      address: CONTRACT_ADDRESS,
      abi: CONTRACT_ABI,
      functionName: 'predictions',
      args: [BigInt(predictionId)],
    });

    const stakeInUSDT = result[3];
    const stake = stakeInUSDT ? formatUnits(result[4], 6) : formatEther(result[4]);
    const targetPrice = formatUnits(result[5], 8); // Price feeds use 8 decimals
    const settledPrice = result[8] ? formatUnits(result[8], 8) : null;

    return {
      id: predictionId,
      user: result[0],
      pair: Number(result[1]),
      pairSymbol: getSymbolFromPair(Number(result[1])),
      isLong: result[2],
      stakeInUSDT: stakeInUSDT,
      stake: stake,
      targetPrice: targetPrice,
      openTime: Number(result[6]),
      duration: Number(result[7]),
      expiry: Number(result[6]) + Number(result[7]),
      settledPrice: settledPrice,
      state: Number(result[9]), // 0: Active, 1: Settled
    };
  } catch (error) {
    console.error(`Error getting prediction ${predictionId}:`, error);
    throw error;
  }
};

/**
 * Get user's prediction IDs from contract
 * @param {string} userAddress - User's wallet address
 * @returns {Promise<Array<number>>} Array of prediction IDs
 */
export const getUserPredictions = async (userAddress) => {
  try {
    const result = await readContract(wagmiConfig, {
      address: CONTRACT_ADDRESS,
      abi: CONTRACT_ABI,
      functionName: 'getUserPredictions',
      args: [userAddress],
    });
    return result.map(id => Number(id));
  } catch (error) {
    console.error('Error getting user predictions:', error);
    throw error;
  }
};

/**
 * Get all predictions for a user from contract
 * @param {string} userAddress - User's wallet address
 * @returns {Promise<Array>} Array of user's predictions
 */
export const getUserPredictionsFromContract = async (userAddress) => {
  try {
    const predictionIds = await getUserPredictions(userAddress);
    const predictions = [];

    for (const id of predictionIds) {
      try {
        const prediction = await getPrediction(id);
          predictions.push(prediction);
      } catch (error) {
        console.warn(`Error fetching prediction ${id}:`, error);
      }
    }

    return predictions;
  } catch (error) {
    console.error('Error getting user predictions from contract:', error);
    throw error;
  }
};

/**
 * Get USDT allowance for a user
 * @param {string} userAddress - User's wallet address
 * @param {string} usdtAddress - USDT token contract address
 * @returns {Promise<bigint>} Current allowance
 */
export const getUSDTAllowance = async (userAddress, usdtAddress) => {
  try {
    if (!userAddress || !usdtAddress) {
      throw new Error('User address and USDT address are required');
    }

    console.log('Getting USDT allowance:', {
      userAddress,
      usdtAddress,
      contractAddress: CONTRACT_ADDRESS
    });

    const allowance = await readContract(wagmiConfig, {
      address: usdtAddress,
      abi: ERC20_ABI,
      functionName: 'allowance',
      args: [userAddress, CONTRACT_ADDRESS],
    });
    
    console.log('USDT allowance retrieved:', allowance.toString());
    return allowance;
  } catch (error) {
    console.error('Error getting USDT allowance:', error);
    console.error('Details:', {
      userAddress,
      usdtAddress,
      contractAddress: CONTRACT_ADDRESS,
      errorMessage: error.message,
      errorStack: error.stack
    });
    throw error;
  }
};

/**
 * Approve USDT token spending
 * @param {string} usdtAddress - USDT token contract address
 * @param {string|number} amount - Amount to approve (in USDT, will be converted to 6 decimals)
 * @returns {Promise<string>} Transaction hash
 */
export const approveUSDT = async (usdtAddress, amount) => {
  try {
    if (!usdtAddress) {
      throw new Error('USDT address is required');
    }
    
    const amountWei = parseUnits(amount.toString(), 6); // USDT has 6 decimals
    
    console.log('Approving USDT:', { 
      usdtAddress, 
      amount, 
      amountWei: amountWei.toString(), 
      contractAddress: CONTRACT_ADDRESS 
    });
    
    const hash = await writeContract(wagmiConfig, {
      address: usdtAddress,
      abi: ERC20_ABI,
      functionName: 'approve',
      args: [CONTRACT_ADDRESS, amountWei],
    });

    console.log('USDT approval transaction hash:', hash);
    return hash;
  } catch (error) {
    console.error('Error approving USDT:', error);
    throw error;
  }
};

/**
 * Check if USDT approval is needed for a given amount
 * @param {string} userAddress - User's wallet address
 * @param {string|number} requiredAmount - Required USDT amount
 * @returns {Promise<{needsApproval: boolean, currentAllowance: string, requiredAmount: string, usdtAddress: string}>}
 */
export const checkUSDTApprovalNeeded = async (userAddress, requiredAmount) => {
  try {
    if (!userAddress) {
      throw new Error('User address is required to check USDT approval');
    }

    // Get USDT token address from contract
    const usdtAddress = await getUSDTAddress();
    
    if (!usdtAddress || usdtAddress === '0x0000000000000000000000000000000000000000') {
      throw new Error('Invalid USDT token address. Please check contract configuration.');
    }

    // Check current allowance
    const currentAllowance = await getUSDTAllowance(userAddress, usdtAddress);
    const requiredAmountWei = parseUnits(requiredAmount.toString(), 6);
    const needsApproval = currentAllowance < requiredAmountWei;

    return {
      needsApproval,
      currentAllowance: currentAllowance.toString(),
      requiredAmount: requiredAmountWei.toString(),
      usdtAddress,
    };
  } catch (error) {
    console.error('Error checking USDT approval:', error);
    throw error;
  }
};

/**
 * Approve USDT and wait for confirmation
 * @param {string} usdtAddress - USDT token contract address
 * @param {string|number} amount - Amount to approve (in USDT, will be converted to 6 decimals)
 * @returns {Promise<{hash: string, receipt: Object}>}
 */
export const approveUSDTAndWait = async (usdtAddress, amount = '1000000') => {
  try {
    const approveHash = await approveUSDT(usdtAddress, amount);
    console.log('Waiting for USDT approval transaction confirmation...');
    
    const receipt = await waitForTransactionReceipt(wagmiConfig, { hash: approveHash });
    
    if (receipt.status !== 'success') {
      throw new Error('USDT approval transaction failed');
    }
    
    console.log('USDT approval confirmed successfully');
    return { hash: approveHash, receipt };
  } catch (error) {
    console.error('Error in approveUSDTAndWait:', error);
    throw error;
  }
};

/**
 * Check and approve USDT if needed before transaction
 * @param {string} userAddress - User's wallet address (optional, will use connected account if not provided)
 * @param {string|number} requiredAmount - Required USDT amount
 * @returns {Promise<void>}
 */
export const ensureUSDTApproval = async (userAddress, requiredAmount) => {
  try {
    if (!userAddress) {
      throw new Error('User address is required for USDT approval');
    }
    
    console.log('Ensuring USDT approval:', { userAddress, requiredAmount });
    
    // Get USDT token address from contract
    const usdtAddress = await getUSDTAddress();
    console.log('USDT token address:', usdtAddress);
    
    if (!usdtAddress || usdtAddress === '0x0000000000000000000000000000000000000000') {
      throw new Error('Invalid USDT token address. Please check contract configuration.');
    }
    
    // Check current allowance
    console.log('Checking allowance for address:', userAddress);
    const currentAllowance = await getUSDTAllowance(userAddress, usdtAddress);
    const requiredAmountWei = parseUnits(requiredAmount.toString(), 6);
    
    console.log('Allowance check:', {
      currentAllowance: currentAllowance.toString(),
      requiredAmountWei: requiredAmountWei.toString(),
      needsApproval: currentAllowance < requiredAmountWei
    });
    
    // If allowance is insufficient, approve
    if (currentAllowance < requiredAmountWei) {
      console.log('Insufficient USDT allowance. Approving 1,000,000 USDT...');
      
      // Approve 1,000,000 USDT for convenience (covers future transactions)
      const approvalAmount = '1000000';
      const approveHash = await approveUSDT(usdtAddress, approvalAmount);
      
      console.log('Waiting for USDT approval transaction confirmation...');
      
      // Wait for approval transaction to be confirmed
      const receipt = await waitForTransactionReceipt(wagmiConfig, { hash: approveHash });
      
      if (receipt.status === 'success') {
        console.log('USDT approval confirmed successfully');
      } else {
        throw new Error('USDT approval transaction failed');
      }
    } else {
      console.log('Sufficient USDT allowance already exists');
    }
  } catch (error) {
    console.error('Error ensuring USDT approval:', error);
    throw error;
  }
};

/**
 * Open a long position
 * @param {string|number} pair - Pair symbol (BTC, ETH, BNB, USDT) or enum value
 * @param {string|number} targetPrice - Target price (will be converted to 8 decimals)
 * @param {number} duration - Duration in seconds
 * @param {boolean} stakeUSDT - Whether to stake in USDT (true) or BNB (false)
 * @param {string|number} usdtAmount - Amount in USDT or BNB (as string or number)
 * @param {string} userAddress - User's wallet address (required for USDT approval)
 * @returns {Promise<string>} Transaction hash
 */
export const long = async (pair, targetPrice, duration, stakeUSDT, usdtAmount, userAddress = null, skipApproval = false, leverage = 1) => {
  try {
    console.log('long function called with:', { pair, targetPrice, duration, stakeUSDT, usdtAmount, userAddress, skipApproval, leverage });
    
    // Get address from connected account if not provided
    if (!userAddress) {
      const account = getAccount(wagmiConfig);
      console.log('Account from getAccount:', account);
      if (!account || !account.address) {
        throw new Error('Wallet not connected. Please connect your wallet first.');
      }
      userAddress = account.address;
      console.log('Using address from getAccount:', userAddress);
    }

    // If using USDT and approval hasn't been handled separately, check and approve first
    if (stakeUSDT && !skipApproval) {
      console.log('Approval needed, calling ensureUSDTApproval');
      await ensureUSDTApproval(userAddress, usdtAmount);
    } else {
      console.log('Skipping approval check:', { stakeUSDT, skipApproval });
    }

    const pairEnum = typeof pair === 'string' ? getPairFromSymbol(pair) : pair;
    const targetPriceWei = parseUnits(targetPrice.toString(), 8); // Price feeds use 8 decimals
    
    // When stakeUSDT is false, usdtAmount parameter should be 0, and BNB is sent as transaction value
    // When stakeUSDT is true, usdtAmount is the USDT amount (6 decimals) and no BNB is sent
    const amount = stakeUSDT 
      ? parseUnits(usdtAmount.toString(), 6) // USDT has 6 decimals
      : 0n; // When using BNB, parameter is 0
    
    const bnbValue = stakeUSDT 
      ? 0n 
      : parseEther(usdtAmount.toString()); // BNB has 18 decimals, sent as transaction value

    const hash = await writeContract(wagmiConfig, {
      address: CONTRACT_ADDRESS,
      abi: CONTRACT_ABI,
      functionName: 'long',
      args: [BigInt(pairEnum), targetPriceWei, BigInt(duration), stakeUSDT, amount],
      value: bnbValue, // Send BNB as transaction value when stakeUSDT is false
    });

    return hash;
  } catch (error) {
    console.error('Error opening long position:', error);
    throw error;
  }
};

/**
 * Open a short position
 * @param {string|number} pair - Pair symbol (BTC, ETH, BNB, USDT) or enum value
 * @param {string|number} targetPrice - Target price (will be converted to 8 decimals)
 * @param {number} duration - Duration in seconds
 * @param {boolean} stakeUSDT - Whether to stake in USDT (true) or BNB (false)
 * @param {string|number} usdtAmount - Amount in USDT or BNB (as string or number)
 * @param {string} userAddress - User's wallet address (required for USDT approval)
 * @returns {Promise<string>} Transaction hash
 */
export const short = async (pair, targetPrice, duration, stakeUSDT, usdtAmount, userAddress = null, skipApproval = false, leverage = 1) => {
  try {
    console.log('short function called with:', { pair, targetPrice, duration, stakeUSDT, usdtAmount, userAddress, skipApproval, leverage });
    
    // Get address from connected account if not provided
    if (!userAddress) {
      const account = getAccount(wagmiConfig);
      console.log('Account from getAccount:', account);
      if (!account || !account.address) {
        throw new Error('Wallet not connected. Please connect your wallet first.');
      }
      userAddress = account.address;
      console.log('Using address from getAccount:', userAddress);
    }

    // If using USDT and approval hasn't been handled separately, check and approve first
    if (stakeUSDT && !skipApproval) {
      console.log('Approval needed, calling ensureUSDTApproval');
      await ensureUSDTApproval(userAddress, usdtAmount);
    } else {
      console.log('Skipping approval check:', { stakeUSDT, skipApproval });
    }

    const pairEnum = typeof pair === 'string' ? getPairFromSymbol(pair) : pair;
    const targetPriceWei = parseUnits(targetPrice.toString(), 8); // Price feeds use 8 decimals
    
    // When stakeUSDT is false, usdtAmount parameter should be 0, and BNB is sent as transaction value
    // When stakeUSDT is true, usdtAmount is the USDT amount (6 decimals) and no BNB is sent
    const amount = stakeUSDT 
      ? parseUnits(usdtAmount.toString(), 6) // USDT has 6 decimals
      : 0n; // When using BNB, parameter is 0
    
    const bnbValue = stakeUSDT 
      ? 0n 
      : parseEther(usdtAmount.toString()); // BNB has 18 decimals, sent as transaction value

    const hash = await writeContract(wagmiConfig, {
      address: CONTRACT_ADDRESS,
      abi: CONTRACT_ABI,
      functionName: 'short',
      args: [BigInt(pairEnum), targetPriceWei, BigInt(duration), stakeUSDT, amount],
      value: bnbValue, // Send BNB as transaction value when stakeUSDT is false
    });

    return hash;
  } catch (error) {
    console.error('Error opening short position:', error);
    throw error;
  }
};

/**
 * Legacy function names for backward compatibility
 * @deprecated Use long or short instead
 */
export const openLongPrediction = async (targetPrice, duration, leverage, oracle, amount) => {
  // Map old parameters to new function
  // Default to BTC pair, ignore leverage (not in new contract)
  return long('BTC', targetPrice, duration, false, amount);
};

export const openShortPrediction = async (targetPrice, duration, leverage, oracle, amount) => {
  // Map old parameters to new function
  // Default to BTC pair, ignore leverage (not in new contract)
  return short('BTC', targetPrice, duration, false, amount);
};

/**
 * Claim prediction payout
 * @param {number} predictionId - Prediction ID
 * @returns {Promise<string>} Transaction hash
 */
export const claimPrediction = async (predictionId) => {
  try {
    const hash = await writeContract(wagmiConfig, {
      address: CONTRACT_ADDRESS,
      abi: CONTRACT_ABI,
      functionName: 'claimPrediction',
      args: [BigInt(predictionId)],
    });

    return hash;
  } catch (error) {
    console.error('Error claiming prediction payout:', error);
    throw error;
  }
};

/**
 * Legacy function name for backward compatibility
 * @deprecated Use claimPrediction instead
 */
export const claimPredictionPayout = async (predictionId) => {
  return claimPrediction(predictionId);
};

/**
 * Wait for transaction receipt
 * @param {string} hash - Transaction hash
 * @returns {Promise<Object>} Transaction receipt
 */
export const waitForTransaction = async (hash) => {
  try {
    const receipt = await waitForTransactionReceipt(wagmiConfig, { hash });
    return receipt;
  } catch (error) {
    console.error('Error waiting for transaction:', error);
    throw error;
  }
};

/**
 * Get contract fee (in basis points)
 * @returns {Promise<bigint>} Fee in basis points
 */
export const getFeeBps = async () => {
  try {
    const result = await readContract(wagmiConfig, {
      address: CONTRACT_ADDRESS,
      abi: CONTRACT_ABI,
      functionName: 'feeBps',
    });
    return result;
  } catch (error) {
    console.error('Error getting fee:', error);
    throw error;
  }
};

/**
 * Oracle getter functions
 */

/**
 * Get BTC/USD oracle address
 * @returns {Promise<string>} Oracle address
 */
export const getBTCOracle = async () => {
  try {
    const result = await readContract(wagmiConfig, {
      address: CONTRACT_ADDRESS,
      abi: CONTRACT_ABI,
      functionName: 'BTC_USD',
    });
    return result;
  } catch (error) {
    console.error('Error getting BTC oracle:', error);
    throw error;
  }
};

/**
 * Get ETH/USD oracle address
 * @returns {Promise<string>} Oracle address
 */
export const getETHOracle = async () => {
  try {
    const result = await readContract(wagmiConfig, {
      address: CONTRACT_ADDRESS,
      abi: CONTRACT_ABI,
      functionName: 'ETH_USD',
    });
    return result;
  } catch (error) {
    console.error('Error getting ETH oracle:', error);
    throw error;
  }
};

/**
 * Get BNB/USD oracle address
 * @returns {Promise<string>} Oracle address
 */
export const getBNBOracle = async () => {
  try {
    const result = await readContract(wagmiConfig, {
      address: CONTRACT_ADDRESS,
      abi: CONTRACT_ABI,
      functionName: 'BNB_USD',
    });
    return result;
  } catch (error) {
    console.error('Error getting BNB oracle:', error);
    throw error;
  }
};

/**
 * Get USDT token address
 * @returns {Promise<string>} USDT token address
 */
export const getUSDTAddress = async () => {
  try {
    const result = await readContract(wagmiConfig, {
      address: CONTRACT_ADDRESS,
      abi: CONTRACT_ABI,
      functionName: 'USDT',
    });
    return result;
  } catch (error) {
    console.error('Error getting USDT address:', error);
    throw error;
  }
};

/**
 * Get MAX_LOOKBACK value
 * @returns {Promise<bigint>} MAX_LOOKBACK value
 */
export const getMaxLookback = async () => {
  try {
    const result = await readContract(wagmiConfig, {
      address: CONTRACT_ADDRESS,
      abi: CONTRACT_ABI,
      functionName: 'MAX_LOOKBACK',
    });
    return result;
  } catch (error) {
    console.error('Error getting MAX_LOOKBACK:', error);
    throw error;
  }
};

/**
 * Owner/admin functions
 */

/**
 * Withdraw BNB from contract (owner only)
 * @param {string} to - Recipient address
 * @param {string|number} amount - Amount in BNB
 * @returns {Promise<string>} Transaction hash
 */
export const withdrawBNB = async (to, amount) => {
  try {
    const amountWei = parseEther(amount.toString());
    const hash = await writeContract(wagmiConfig, {
      address: CONTRACT_ADDRESS,
      abi: CONTRACT_ABI,
      functionName: 'withdrawBNB',
      args: [to, amountWei],
    });
    return hash;
  } catch (error) {
    console.error('Error withdrawing BNB:', error);
    throw error;
  }
};

/**
 * Withdraw USDT from contract (owner only)
 * @param {string} to - Recipient address
 * @param {string|number} amount - Amount in USDT
 * @returns {Promise<string>} Transaction hash
 */
export const withdrawUSDT = async (to, amount) => {
  try {
    const amountWei = parseUnits(amount.toString(), 6); // USDT has 6 decimals
    const hash = await writeContract(wagmiConfig, {
      address: CONTRACT_ADDRESS,
      abi: CONTRACT_ABI,
      functionName: 'withdrawUSDT',
      args: [to, amountWei],
    });
    return hash;
  } catch (error) {
    console.error('Error withdrawing USDT:', error);
    throw error;
  }
};
